/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface TAPLeaderboardRequest {

    /**
     * Amount of affilliate commissions over the period
     */
    commissions?: string;

    /**
     * Affiliate commission rank over the period
     */
    rank?: number;

    /**
     * If true affiliate is private on the leaderboard
     */
    keep_private?: boolean;

    /**
     * Affiliate's display name
     */
    username?: string;

    /**
     * Avatar URL
     */
    avatar?: string;

}

@Model('TAPLeaderboard')
export class ApiTAPLeaderboard extends BaseModel implements TAPLeaderboardRequest {

    /**
     * Amount of affilliate commissions over the period
     */
    
    
    commissions: string;

    /**
     * Affiliate commission rank over the period
     */
    
    
    rank: number;

    /**
     * If true affiliate is private on the leaderboard
     */
    
    
    keep_private: boolean;

    /**
     * Affiliate's display name
     */
    
    
    username: string;

    /**
     * Avatar URL
     */
    
    
    avatar: string;

}
